// import firebase from 'firebase'
// import 'firebase/firestore'
import firebase from '../lib/firebase'

const db = firebase.firestore()
db.settings({ timestampsInSnapshots: true, merge: true })

export default db
